import { PipeTransform, Pipe, ChangeDetectorRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

/**
 * Wrapper around [TranslatePipe](https://github.com/ngx-translate/core) to support translating into a particular locale passed as the first argument to the pipe.
 * ### Usage:
 *   `key | translate2:locale[:interpolateParams]`
 * ### Example:
 *   `{{ 'some.key' | translate2:'en-us' }}`
 *
 *   `{{ 'some.key' | translate2:'es-us':{ name: 'John' } }}`
 */
@Pipe({
  name: 'translate2',
})
export class Translate2Pipe extends TranslatePipe implements PipeTransform {
  constructor(public _translate: TranslateService, _ref: ChangeDetectorRef) {
    super(_translate, _ref);
  }

  override transform(
    query: string,
    lang: string,
    interpolateParams?: object,
  ): string {
    if (this.lastKey) {
      // any required as typings are wrong
      this.lastKey = null as any;
    }
    // needed as updateValue internally uses currentLang
    const currentLang = this._translate.currentLang;
    this._translate.currentLang = lang;

    this.updateValue(
      query,
      interpolateParams,
      this._translate.translations[lang],
    );
    this._translate.currentLang = currentLang;

    return this.value;
  }
}
